import Info from '../../Tabs/Info.js';
import AdvancedSettings from '../../Tabs/AdvancedSettings.js';
import ClimateSettings from '../../Tabs/ClimateSettings.js';
import Co2Settings from '../../Tabs/Co2Settings.js';
import LightsSettings from '../../Tabs/LightsSettings.js';
import SystemSettings from '../../Tabs/SystemSettings.js';
import TimingSettings from '../../Tabs/TimingSettings.js';
import VentilationSettings from '../../Tabs/VentilationSettings.js';
import MultiOutSettings from '../../Tabs/MultiOutSettings.js';
import OverwriteIOSettings from '../../Tabs/OverwriteIOSettings.js';
import EquipmentSettings from '../../Tabs/EquipmentSettings.js';
import AlarmSettings from '../../Tabs/AlarmSettings.js';
import FlexAlarmSettings from '../../Tabs/FlexAlarmSettings.js';
import Scheduling from '../../Tabs/Scheduling.js';
import { MemorizedGraph } from '../../Tabs/Graph';
//import PerformanceTest from '../../Tabs/PerformanceTest';

import MultipleNutrientSettings, { NutrientSettings } from '../../Tabs/NutrientSettings.js';
import MultipleIrrigationSettings from '../../Tabs/IrrigationSettings';

export const useConfigObject = (controller, recoveryMode) => {
  const tabs = [
    {
      id: 'info',
      label: 'Info',
      content: <Info />
    },
    {
      id: 'graph',
      label: 'Graph',
      content: <MemorizedGraph />
    },
    {
      id: 'climate',
      label: 'Climate',
      content: <ClimateSettings />
    },
    {
      id: 'lights',
      label: 'Lights',
      content: <LightsSettings />
    },
    {
      id: 'irrigation',
      label: 'Irrigation',
      content: <MultipleIrrigationSettings />
    },
    {
      id: 'nutrition',
      label: 'Nutrition',
      content: controller.zones ? <MultipleNutrientSettings /> : <NutrientSettings />
    },
    {
      id: 'timing',
      label: 'Timing',
      content: <TimingSettings />
    },
    {
      id: 'co2',
      label: 'C02',
      content: <Co2Settings />
    },
    {
      id: 'scheduling',
      label: 'Scheduling',
      content: <Scheduling />
    },
    {
      id: 'ventilation',
      label: 'Ventilation',
      content: <VentilationSettings />
    },
    {
      id: controller.type === 6000 || controller.type === 5155 ? 'multi_in_out' : 'outputs',
      label: controller.type === 6000 || controller.type === 5155 ? 'Multi I/O' : 'Outputs',
      content: <MultiOutSettings />
    },
    {
      id: 'alarms',
      label: 'Alarms',
      content: controller.api_version >= 'BAI' ? <FlexAlarmSettings /> : <AlarmSettings />
    },
    {
      id: 'advanced',
      label: 'Advanced',
      content: <AdvancedSettings />
    }
    /*,
    {
      id: 'performance_test',
      label: 'Performance Test',
      content: <PerformanceTest />
    }*/
  ];

  // Does not support multi-zone
  if (!controller.zones) {
    tabs.splice(13, 0, {
      id: 'system',
      label: 'System',
      content: recoveryMode ? <SystemSettings recoveryMode={true} /> : <SystemSettings />
    });
  } else if (controller.zones) {
    // Supports multi-zone
    tabs.splice(11, 0, {
      id: 'overwr_in_out',
      label: 'Overwrite I/O',
      content: <OverwriteIOSettings />
    });
    tabs.splice(12, 0, {
      id: 'equipment',
      label: 'Equipment',
      content: <EquipmentSettings />
    });
  }

  return tabs;
};
